(() => {
  const source = document.getElementById('oyah-purchase-data');
  if (!source || source.dataset.initialized) return;
  source.dataset.initialized = 'true';
  const data = JSON.parse(source.textContent);
  const format = new Intl.NumberFormat(data.locale, {style: 'currency', currency: data.currency, currencyDisplay: 'code'});
  const money = cents => format.format(cents / 100);
  const main = document.getElementById('MainContent');
  if (!main) return;
  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };
  const parseJSON = value => {
    try { return typeof value === 'string' ? JSON.parse(value) : value; } catch { return null; }
  };
  const forms = () => [...main.querySelectorAll('form[action*="/cart/add"]')].filter(form => {
    const id = form.querySelector('[name="id"]')?.value;
    return data.variants.some(variant => String(variant.id) === String(id));
  });
  let scheduled = false;
  function update() {
    scheduled = false;
    for (const form of forms()) {
      const section = form.closest('.shopify-section') || main;
      const widget = section.querySelector('.appstle-volume-discount');
      const ruleNode = widget?.querySelector('.ab-volume-discount-rule-item');
      const selectedCard = widget?.querySelector('.ab-volume-discount-rule-content-v2 [role="radio"][aria-checked="true"]')?.closest('.ab-volume-discount-item-container-v2');
      const title = selectedCard?.querySelector('.ab-volume-discount-item-title-label-v2')?.textContent || '';
      const quantityInput = form.querySelector('[name="quantity"]');
      const hasPackSelector = Boolean(widget?.querySelector('.ab-volume-discount-rule-content-v2'));
      const quantity = hasPackSelector ? Number(title.match(/^\s*(\d+)/)?.[1] || 1) : Math.max(1, Number(quantityInput?.value) || 1);
      const variant = data.variants.find(item => String(item.id) === String(form.querySelector('[name="id"]')?.value)) || data.variants[0];
      if (!variant) continue;
      const subscription = widget?.querySelector('.ab-volume-subscription-container-v3[aria-checked="true"]');
      const frequency = widget?.querySelector('select[aria-label="Delivery frequency"]');
      const planId = subscription ? frequency?.value || form.querySelector('[name="selling_plan"]')?.value : form.querySelector('[name="selling_plan"]')?.value;
      const allocation = planId ? variant.allocations.find(item => String(item.id) === String(planId)) : null;
      const unitPrice = allocation ? allocation.price : variant.price;
      const rules = window._ABConfig?.bundle_rules || [];
      const rule = rules.find(item => item.uniqueRef === ruleNode?.dataset.appstleBundlesWidgetUniqueRef);
      const tiers = parseJSON(rule?.tieredDiscount) || [];
      const tier = tiers.filter(item => item.discountBasedOn === 'QUANTITY' && Number(item.value) <= quantity).sort((a,b) => Number(b.value) - Number(a.value))[0];
      let reduction = 0;
      if (tier?.discountType === 'PERCENTAGE') reduction = Math.round(unitPrice * quantity * Number(tier.discount || 0) / 100);
      const supportedTier = !tier || tier.discountType === 'PERCENTAGE';
      if (!supportedTier) continue;
      const total = Math.max(0, unitPrice * quantity - reduction);
      const oneTime = !subscription && !allocation;
      const selectedSchedule = frequency?.selectedOptions[0]?.textContent?.trim() || allocation?.name || data.texts.chooseSchedule;
      const summary = form.querySelector('[data-oyah-purchase-summary]') || (() => {
        const element = document.createElement('div');
        element.className = 'oyah-purchase-summary';
        element.dataset.oyahPurchaseSummary = '';
        element.setAttribute('aria-live', 'polite');
        element.innerHTML = '<p class="oyah-purchase-summary__total" data-total></p><p data-units></p><p data-schedule></p><p class="oyah-purchase-summary__note" data-note></p>';
        form.querySelector('.product-form-buttons')?.before(element);
        return element;
      })();
      setText(summary.querySelector('[data-total]'), `${data.texts.total}: ${money(total)}`);
      setText(summary.querySelector('[data-units]'), `${quantity} ${quantity === 1 ? data.texts.pack : data.texts.packs} · ${money(Math.round(total / quantity))} ${data.texts.perPack}`);
      setText(summary.querySelector('[data-schedule]'), oneTime ? data.texts.oneTime : `${data.texts.recurring}: ${selectedSchedule}.`);
      setText(summary.querySelector('[data-note]'), data.texts.costNote);
      const sticky = section.querySelector('sticky-add-to-cart');
      const buttons = [...form.querySelectorAll('button[name="add"]'), ...sticky?.querySelectorAll('.sticky-add-to-cart__button') || []];
      for (const button of buttons) {
        const text = button.querySelector('.add-to-cart-text');
        if (!text) continue;
        const amount = text.querySelector('[data-oyah-atc-total]') || (() => {
          const span = document.createElement('span');
          span.className = 'oyah-atc-total';
          span.dataset.oyahAtcTotal = '';
          text.append(span);
          return span;
        })();
        setText(amount, `· ${money(total)}`);
      }
      const quantityWrapper = quantityInput?.closest('.quantity-selector-wrapper');
      quantityWrapper?.classList.toggle('oyah-pack-quantity-hidden', hasPackSelector);
      const subtitle = widget?.querySelector('.ab-volume-subscription-information-subtitle-v3');
      setText(subtitle, subscription ? selectedSchedule : data.texts.chooseSchedule);
      for (const card of widget?.querySelectorAll('.ab-volume-discount-item-price-info-v2') || []) {
        if (card.querySelector('[data-oyah-unit-label]')) continue;
        const label = document.createElement('span');
        label.className = 'oyah-pack-unit';
        label.dataset.oyahUnitLabel = '';
        label.textContent = data.texts.perPack;
        card.append(label);
      }
      setText(widget?.querySelector('.ab-volume-discount-most-popular-badge-label'), data.texts.refillOption);
      const stickyPrice = sticky?.querySelector('.sticky-add-to-cart__price');
      if (stickyPrice) {
        const oldPrice = stickyPrice.querySelector('[ref="priceContainer"]');
        if (oldPrice) oldPrice.hidden = true;
        const stickyAmount = stickyPrice.querySelector('[data-oyah-sticky-total]') || (() => {
          const span = document.createElement('span');
          span.dataset.oyahStickyTotal = '';
          stickyPrice.append(span);
          return span;
        })();
        setText(stickyAmount, `${data.texts.total}: ${money(total)}`);
      }
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  main.addEventListener('change', schedule, true);
  main.addEventListener('input', schedule, true);
  main.addEventListener('click', schedule, true);
  new MutationObserver(schedule).observe(main, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-checked', 'value', 'data-selected-variant-id']});
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
